import React, { useState, useEffect } from 'react';
import { FaUser, FaLock, FaEye, FaEyeSlash, FaSignInAlt, FaSpinner } from 'react-icons/fa';
import { useAuth } from '../context/AuthContext';
import { useNavigate, useLocation } from 'react-router-dom';

const LoginPage = () => {
  const [showPassword, setShowPassword] = useState(false);
  const [rememberMe, setRememberMe] = useState(false);
  const { login } = useAuth();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    username: '',
    password: ''
  });

  const [usernameValid, setUsernameValid] = useState(true);
  const navigate = useNavigate();
  const location = useLocation();

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

   const validateUsername = (username) => {
    const usernameRegex = /^[a-zA-Z0-9_]{3,30}$/;
    return usernameRegex.test(username);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));

    if (name === 'username') {
      setUsernameValid(validateUsername(value));
    }
  };

   useEffect(() => {
     const hasSavedResults = localStorage.getItem('hasSavedTestResults');
    const redirectPath = localStorage.getItem('testResults_redirectPath');
    
    if (hasSavedResults === 'true' && redirectPath) {
      console.log('تم العثور على نتائج اختبار محفوظة للعودة إلى:', redirectPath);
    }
  }, [location.state]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!validateUsername(formData.username)) {
      alert('اسم المستخدم يجب أن يحتوي على 3-30 حرفاً (أحرف إنجليزية، أرقام و _ فقط)');
      return;
    }

    setLoading(true);

    const result = await login(formData.username, formData.password);
    
    setLoading(false);

    if (result.success) {
      console.log('تم تسجيل الدخول بنجاح!', result.data);
      
       const hasSavedResults = localStorage.getItem('hasSavedTestResults');
      const redirectPath = localStorage.getItem('testResults_redirectPath');
      
      if (hasSavedResults === 'true' && redirectPath) {
        console.log('العودة إلى شاشة النتائج مع البيانات المحفوظة');
        
         localStorage.removeItem('hasSavedTestResults');
        localStorage.removeItem('testResults_redirectPath');
        
         localStorage.setItem('returnToResults', 'true');
        
         navigate('/tests');
      } else {
         window.location.href = '/';
      }
    } else {
      alert(`فشل تسجيل الدخول: ${result.error}`);
    }
  };

  return (
    <div className="min-h-screen grid-pattern flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8 relative overflow-hidden" dir="rtl">
       <div className="absolute top-20 left-10 w-72 h-72 bg-[#320A6B] opacity-5 rounded-full blur-3xl float-animation"></div>
      <div className="absolute bottom-20 right-10 w-96 h-96 bg-[#B8860B] opacity-5 rounded-full blur-3xl float-animation" style={{ animationDelay: '2s' }}></div>
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-[#320A6B] opacity-5 rounded-full blur-3xl"></div>

      <div className="relative w-full max-w-md">
         <div className="text-center mb-8">
          <h1 className="text-3xl font-bold text-gray-900 mt-6">تسجيل الدخول</h1>
          <p className="mt-2 text-gray-600">مرحباً بعودتك! سجّل دخولك للمتابعة</p>
        </div>

         <div className="card-subtle rounded-2xl shadow-xl p-8">
          <form className="space-y-6" onSubmit={handleSubmit}>
             <div>
              <label htmlFor="username" className="block text-sm font-semibold text-gray-700 mb-2">
                اسم المستخدم
              </label>
              <div className="relative">
                <div className="absolute inset-y-0 right-0 pr-4 flex items-center pointer-events-none">
                  <FaUser className="text-gray-400" />
                </div>
                <input
                  type="text"
                  id="username"
                  name="username"
                  required
                  value={formData.username}
                  onChange={handleInputChange}
                  className={`input-subtle w-full pr-12 pl-4 py-3.5 rounded-xl text-base ${
                    !usernameValid && formData.username ? 'border-red-500' : ''
                  }`}
                  placeholder="اسم المستخدم"
                />
              </div>
              {!usernameValid && formData.username && (
                <p className="mt-1 text-xs text-red-500">
                  اسم المستخدم يجب أن يحتوي على 3-30 حرفاً (أحرف إنجليزية، أرقام و _ فقط)
                </p>
              )}
              {usernameValid && formData.username && (
                <p className="mt-1 text-xs text-green-500">
                  ✓ اسم المستخدم صالح
                </p>
              )}
            </div>

             <div>
              <label htmlFor="password" className="block text-sm font-semibold text-gray-700 mb-2">
                كلمة السر
              </label>
              <div className="relative">
                <div className="absolute inset-y-0 right-0 pr-4 flex items-center pointer-events-none">
                  <FaLock className="text-gray-400" />
                </div>
                <input
                  type={showPassword ? "text" : "password"}
                  id="password"
                  name="password"
                  required
                  value={formData.password}
                  onChange={handleInputChange}
                  className="input-subtle w-full pr-12 pl-12 py-3.5 rounded-xl text-base"
                  placeholder="••••••••"
                />
                <button
                  type="button"
                  onClick={togglePasswordVisibility}
                  className="absolute inset-y-0 left-0 pl-4 flex items-center text-gray-400 hover:text-gray-600 transition-colors"
                >
                  {showPassword ? <FaEyeSlash /> : <FaEye />}
                </button>
              </div>
            </div>

             <button
              type="submit"
              disabled={loading}
              className="w-full bg-[#320A6B] hover:bg-[#4a1a8c] text-white font-semibold py-3.5 rounded-xl transition-all duration-300 shadow-lg hover:shadow-xl transform hover:-translate-y-0.5 disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {loading ? (
                <>
                  <FaSpinner className="ml-2 inline animate-spin" />
                  جاري تسجيل الدخول...
                </>
              ) : (
                <>
                  <FaSignInAlt className="ml-2 inline" />
                  تسجيل الدخول
                </>
              )}
            </button>
          </form>
        </div>

         <p className="mt-6 text-center text-sm text-gray-600">
          ليس لديك حساب؟
          <a href="/register" className="font-semibold text-[#320A6B] hover:text-[#4a1a8c] transition-colors mr-1">
            إنشاء حساب جديد
          </a>
        </p>
      </div>

       <style jsx>{`
        .grid-pattern {
          background-image:
            linear-gradient(rgba(50, 10, 107, 0.03) 1px, transparent 1px),
            linear-gradient(90deg, rgba(50, 10, 107, 0.03) 1px, transparent 1px);
          background-size: 30px 30px;
        }

        .input-subtle {
          background: rgba(255, 255, 255, 0.6);
          border: 1.5px solid rgba(0, 0, 0, 0.1);
          transition: all 0.3s ease;
        }

        .input-subtle:focus {
          outline: none;
          border-color: #320A6B;
          background: rgba(255, 255, 255, 0.9);
          box-shadow: 0 0 0 3px rgba(50, 10, 107, 0.1);
        }

        .card-subtle {
          background: rgba(255, 255, 255, 0.8);
          border: 1px solid rgba(0, 0, 0, 0.08);
          backdrop-filter: blur(20px);
        }

        @keyframes float {
          0%, 100% { transform: translateY(0px); }
          50% { transform: translateY(-20px); }
        }

        .float-animation {
          animation: float 6s ease-in-out infinite;
        }
      `}</style>

      <style jsx global>{`
        body {
          font-family: 'Cairo', sans-serif;
        }
      `}</style>
    </div>
  );
};

export default LoginPage;